import { hideSkeleton } from '@store/common/actions';
import { objectBalances } from '@helpers';
import { searchDate } from '@helpers/utils';
import * as andesService from '@services/andes-service';
import * as fondsoutService from '@services/funds-out-service';
import * as andesType from './actionTypes';

export const fetchAndesBalance = () => ({
  type: andesType.FETCH_ANDES_BALANCE,
});

export const setAndesErrorGSC = (error) => ({
  type: andesType.SET_ANDES_ERROR_GSC,
  payload: {
    error,
    errGsc: true,
  },
});

export const setAndesErrorMerchantBalance = (error) => ({
  type: andesType.SET_ANDES_ERROR_MERCHANT_BALANCE,
  payload: {
    error,
    errMerchant: true,
  },
});

export const setAndesErrorMerchantAvailable = (error) => ({
  type: andesType.SET_ANDES_ERROR_MERCHANT_AVAILABLE,
  payload: {
    error,
    errMerchantAvailable: true,
  },
});

export const setAndesErrorAllBalance = (error) => ({
  type: andesType.SET_ANDES_ERROR_ALL_BALANCE,
  payload: {
    error,
    errAllBalances: true,
  },
});

export const setGscBalance = (data) => ({
  type: andesType.SET_GSC_BALANCE,
  payload: data,
});

export const setMerchantBalance = (data) => ({
  type: andesType.SET_MERCHANT_BALANCE,
  payload: data,
});

export const setAllBalance = (data) => ({
  type: andesType.SET_ALL_BALANCE,
  payload: data,
});

export const setMerchantAvailable = (data) => ({
  type: andesType.SET_MERCHANT_AVAILABLE,
  payload: data,
});

export const setTotalBalance = (data) => ({
  type: andesType.SET_TOTAL_BALANCE,
  payload: data,
});

export const setAdvanceableIncome = (data) => ({
  type: andesType.SET_ADVANCEABLE_INCOME,
  payload: data,
});

export const setLoadedAmounts = (data) => ({
  type: andesType.SET_LOADED_AMOUNT,
  payload: data,
});

export const fetchGscBalance = (seller_id) => (dispatch) =>
  andesService
    .getGscBalance(seller_id)
    .then((res) => {
      dispatch(setGscBalance(res));
    })
    .catch((error) => {
      console.log('ERROR:', error);
      dispatch(setAndesErrorGSC(error));
    });

export const fetchAllBalance = () => (dispatch) => {
  const dates = searchDate();
  const queryDates = `start_date=${dates[0]}&end_date=${dates[1]}`;

  return andesService
    .getAllBalance(queryDates)
    .then((res) => dispatch(setAllBalance(res)))
    .catch((error) => {
      console.log('ERROR:', error);
      dispatch(setAndesErrorAllBalance(error));
    });
};

export const fetchMerchantAvailable = (merchant_id) => (dispatch) => {
  const query = objectBalances(merchant_id);

  fondsoutService
    .getBalances(query)
    .then((res) => {
      dispatch(setTotalBalance(res));
      dispatch(setMerchantAvailable(res.total));
      if (res.sellerMerchant) dispatch(setAdvanceableIncome(res.sellerMerchant.subTotal));
      dispatch(hideSkeleton());
    })
    .catch((error) => {
      console.log('ERROR:', error);
      dispatch(setAndesErrorMerchantAvailable(error));
      dispatch(hideSkeleton());
    });
};

export const fetchMerchantBalance = () => (dispatch) => {
  fondsoutService
    .getAvailable()
    .then((res) => {
      dispatch(setMerchantBalance(res));
      dispatch(hideSkeleton());
      dispatch(setLoadedAmounts(true));
    })
    .catch((error) => {
      console.log('ERROR:', error);
      dispatch(setAndesErrorMerchantBalance(error));
      dispatch(hideSkeleton());
    });
};

export const setAmountWithraw = (data) => ({
  type: andesType.SET_AMOUNT_WITHRAW,
  payload: data,
});
